/**
 * Ticket #54 — Pastille « Interne » : affaire interne (temps non facturable,
 * jamais exportée vers Gescom). Affichée dans les listes et les pickers
 * d'affaires. `expiresAt` (optionnel) enrichit l'infobulle.
 */
export const INTERNAL_AFFAIRE_TITLE =
  'Affaire interne : temps non facturable, jamais exporté vers Gescom';

function formatDay(iso) {
  if (!iso) return null;
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}/${y}` : null;
}

export default function InternalAffaireBadge({ expiresAt = null, size = 'md' }) {
  const expiry = formatDay(expiresAt);
  const title = expiry ? `${INTERNAL_AFFAIRE_TITLE} — expire le ${expiry}` : INTERNAL_AFFAIRE_TITLE;
  return (
    <span
      title={title}
      style={{
        display: 'inline-block',
        padding: size === 'sm' ? '0 6px' : '2px 10px',
        borderRadius: 'var(--radius-pill)',
        fontSize: size === 'sm' ? 10 : 11,
        fontWeight: 500,
        lineHeight: size === 'sm' ? '16px' : undefined,
        background: 'var(--glass)',
        color: 'var(--accent)',
        border: '1px solid var(--accent)',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      Interne
    </span>
  );
}
